import React from 'react';
import classNames from 'classnames';

import styles from './SubtleButton.module.scss';

interface Props {
  shrink?: boolean;
  pill?: boolean;
  children: React.ReactNode;
  onClick(): void;
}

export default function SubtleButton({shrink, pill, children, onClick}: Props) {
  const subtleButtonClassName = classNames(
    styles.SubtleButton,
    shrink && styles.shrink,
    pill && styles.pill,
  );

  return (
    <button className={subtleButtonClassName} type="button" onClick={onClick}>
      {children}
    </button>
  );
}
